export default __webpack_public_path__ + "static/media/g2022-9.5c0fab82.jpeg";